import { ChangeDetectorRef, Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { AlertService, CommonService, ControlFileService, DocumentsService, RxService } from 'src/app/services';
import * as moment from "moment";
import { FormBuilder, FormGroup } from '@angular/forms';
import { CollectionView } from '@grapecity/wijmo';
import { DomSanitizer } from '@angular/platform-browser';
import { PrintService } from 'src/app/services/print.service';
import { PaginationModel, SystemData, resolveErrorEnum, submissionStatusNotif } from 'src/app/models';
import { ColorCode, CommonUtil, NRxUtils, ValidateFormFieldsUtils, WijimoUtil } from 'src/app/utils';
import { AccCategoryE, RxE } from 'src/app/models';
import { PrivMaskGuard } from 'src/app/guards';
import { EdRxComponent } from 'src/app/modules/ed-rx';
import * as wjcGrid from "@grapecity/wijmo.grid";
import { ColorCodeRx } from 'src/app/utils/rx-color.util';
import { HoverOver } from 'src/app/utils/hover-over.util';
import { CommonStore } from 'src/app/store';
import { MsgConfig } from 'src/app/app.messages';
import { FormatsUtil } from 'src/app/utils/formats.util';
import { StorageService } from 'src/app/services/storage.service';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { environment } from "src/environments/environment";
@Component({
  selector: 'app-display-notifications',
  templateUrl: './display-notifications.component.html'
})
export class DisplayNotificationsComponent implements OnInit {
  isActive = true;
  activeSubMenu: string;
  upArrowIcon:boolean = true;
  openSuccessBlock:boolean = false;
  openErrorBlock:boolean = false;
  zeroReportingBlock:boolean = false;
  CountDetails:any;
  nabpNum:any;
  date:any;
  today: any;
  displaySuccessCount:CollectionView;
  displayErrorCount:CollectionView;
  displayZeroReportingCount:CollectionView;
  actvCtrlHeaders = ["State", "Notification Date Time","Status","Actions"];
  notificationDisplayFG:FormGroup;
  maxDate: { year: number; month: number; day: number; };
  previewWJ: CollectionView;
  pdfSrc: any;
  showSuccessDocPreview:boolean = false;
  showErrorDocPreview:boolean = false;
  showZeroReportDocPreview:boolean = false;
  successCount:any = [];
  ErrorCount:any = [];
  RxCount:any = [];
  submittedDate:any;
  @Output()
  popupClosed = new EventEmitter<any>();
  @Output()
  notificationCountAfterPreview = new EventEmitter<any>();
  alreadyRead :boolean = true;
  @Input() NotificationCount:any;
  printNotif:any;
  // userReviewStatus:any;
  submissionNotif : boolean = true;
controlFileErrorNY :boolean;
wjHeaders:any;
controlError:boolean;
wjHeaders2:any;
errorResponse:any;
controlErrorWJ: CollectionView;
showNYErrorsWJ:CollectionView;
newYorkErros: any;
selectedrxNo: any;
  selectedrxId: any;
  accessPrivCate:  any;
  rxPrivs: any;
  categoryId: any;
  privType: any;
  openOverride: boolean;
  overrideEndpoint: any;
  controlErrorWWJ:CollectionView;
  errors:any;
  // ErrorUpdateStatus:boolean;
  rxWijmo: wjcGrid.FlexGrid;
  totalRecordsLength: any;
  successLength: any;
  resolvedCount: any;
  unResolvedCount: any;
  systemData: SystemData;
  yesterday: any;
  selectedError: any;
  selectedFilter: any;
  IsActiveTabName: string = 'ASAP';
  @ViewChild("myUL", { static: true })
      myUL: ElementRef;
  paginationModel: PaginationModel = new PaginationModel();
  pageNumber = this.paginationModel.pageNumber;
  pageSize = this.paginationModel.pageSize;
  startIndex: number;
  notificationCounts: any;
  totalCount: any;
  unsubscribe$: Subject<void> = new Subject();
  wjHeaders3: any[];
  pharmacyState: any;
  submissionStatusEnums = submissionStatusNotif;
  errorsNY: any;
  errorResponseNY: any;
  unResolvedCountNY: any;
  resolvedCountNY: any;
  isEnableNYErrors = environment.isEnableNYErrors;
  totalNYRecordsLength: any;
  constructor( private _colorCodeRx: ColorCodeRx, private _formUtils: ValidateFormFieldsUtils, private _comnUtil: CommonUtil, private _commonStore: CommonStore,private _alertSer: AlertService,  private _hoverOver: HoverOver, private _modalService: NgbModal,private _colorCode: ColorCode,private _privMaskGuard: PrivMaskGuard,private _printServ: PrintService,  private _nrxUtls: NRxUtils, private _cmnSvc: CommonService,private _wijimoUtils: WijimoUtil,public activeModal: NgbActiveModal, private _rxService: RxService, private _fb: FormBuilder, private _controlFileSvc: ControlFileService,private sanitizer: DomSanitizer,private _cdr: ChangeDetectorRef, public _storageService: StorageService,

    private _formatsUtil:FormatsUtil, private _docService : DocumentsService
  ) {
    this.accessPrivCate = AccCategoryE;
    this.rxPrivs = RxE;
   }

  ngOnInit() {
    this._cmnSvc.systemData$.subscribe(resp => {
      this.systemData = resp;
  });
    this.maxDate = {
        year: moment(this.today).year(),
        month: moment(this.today).month() + 1,
        day: moment(this.today).date()
    };
    this.today = moment().format(MsgConfig.DATE_FORMAT);
    this.yesterday = moment().subtract(1, "day").format(MsgConfig.DATE_FORMAT)
    this.createFG();
    this.setDefaultValues();
    this.patchDefaultValHeaders();
    this._wijimoUtils.wjSavedData$.subscribe(w => {
        if (w && w["WijmoKey"] && (w["WijmoKey"] === "controlFileError" || w["WijmoKey"] === "controlFileErrorForNY" || w["WijmoKey"]=== "submissionLog")) {
            this.patchDefaultValHeaders();
        }
    });
    this.pharmacyState = this._cmnSvc.getSetttingValue("TenantSettings", "TNT_STATE");
    // this.onSearch();
    this.countstoDisplay();
    this.searchForControlErrorData();
    this.openControlFileError();
  }
  closePopUp(){
    this.popupClosed.emit(true);
    if (this.activeModal) {
      this.activeModal.close();
    }

  }
  countstoDisplay() {
    const readNotification = {
      fromDate: this.notificationDisplayFG.controls["fromDate"].value,
      toDate : this.notificationDisplayFG.controls["toDate"].value
    }
    this._rxService.detailsForDisplayNotificationCount(readNotification).subscribe(notifCount=>{
      if(notifCount){
        this.notificationCounts = notifCount;
        this.notificationCountAfterPreview.emit(notifCount);
      }
    })
  }
  createFG(){
    this.notificationDisplayFG = this._fb.group({
        fromDate:null,
        toDate: null,
        statusDropdwn:null,
        FromDate:null,
        ToDate:null,
        
        pageNumber: this.paginationModel.pageNumber,
        pageSize: this.paginationModel.pageSize,
        subType: 2
        
    });
  }
  setDefaultValues(){
    this.notificationDisplayFG.controls["fromDate"].patchValue(this.yesterday);
    this.notificationDisplayFG.controls["toDate"].patchValue(this.today);
    this.notificationDisplayFG.controls["FromDate"].patchValue(this.yesterday);
    this.notificationDisplayFG.controls["ToDate"].patchValue(this.today);
    this.notificationDisplayFG.controls["statusDropdwn"].patchValue(1);
    this.notificationDisplayFG.controls["pageNumber"].patchValue(1);
    this.notificationDisplayFG.controls["pageSize"].patchValue(60);
    
  }
  async patchDefaultValHeaders() {
    const storedWJ = await this._wijimoUtils.getWJSavedData("controlFileError");
    this.wjHeaders = this._wijimoUtils.patchDefHeader("controlFileError", storedWJ);
    const storedWJ2 = await this._wijimoUtils.getWJSavedData("controlFileErrorForNY");
    this.wjHeaders2 = this._wijimoUtils.patchDefHeader("controlFileErrorForNY", storedWJ2);
    
    const storedWJ3 = await this._wijimoUtils.getWJSavedData("submissionLog");
    this.wjHeaders3 = this._wijimoUtils.patchDefHeader("submissionLog", storedWJ3);
    
}
loadReportData(data) {
  const mapDataSet=[];
    data.map((item, i) => {
          const k = {};
          k["State"] = item.StateName;
          k["NotificationDateTime"] = (item.CreatedDtTm) ? item.CreatedDtTm:"";
        //   k["Notification Date Time"] =(item.CreatedDtTm) ? moment.utc(item.CreatedDtTm).local().format(
        //     "MM/DD/YYYY hh:mm:ss a"
        // ) : "";
        //   k["Action"] = "";
        //   k["Status"] = "";
          k["SuccessCount"] = item.SuccessCount;
          k["ErrorCount"] = item.ErrorCount;
          k["RxCount"] = item.RxCount;
          k["FailureCount"] = item.FailureCount;
          k["UserReviewStatus"] = item.UserReviewStatus ?  true : false;
          
          k["Submission DtTm"] =(item.CreatedDtTm) ? moment.utc(item.CreatedDtTm).local().format(
            "MM/DD/YYYY hh:mm:ss a") : "";
          k["Report Status"] = "";
          k["Submission Status"] = "";
          k["Submission Type"]= item && (item.SubmissionType || item.SubmissionType === 0) ? (item.SubmissionType === 1 ? 'Auto' : 'Manual') : "";
          k["No. Of Rx(s)"]= item.SuccessCount + item.ErrorCount + item.FailureCount;
          k["FileName"] = item.Name + item.Extn;
          k["Id"] = item.Id;
          k["extn"] = item.Extn;
          k["FTPUploaded"] = item.FTPUploaded ? item.FTPUploaded : "";
          k["SubmittedToPdmp"] = item.SubmittedToPdmp ? item.SubmittedToPdmp : "";
          k["FileTypeId"] = item.FileTypeId ? item.FileTypeId : "";
          k["FTPUploadStatus"]=item.FTPUploadStatus;
          k["PDMPUploadStatus"] = item.PDMPUploadStatus;
          
          mapDataSet.push(k)
    });
  this.displaySuccessCount = new CollectionView(mapDataSet,
              {
                 sortComparer: (a: any, b: any) => {
                      return moment(a).isValid() && moment(b).isValid()
                          ? moment(a).diff(moment(b)) : null;
                  }
              });

}
async onSearch(val?, frmSideClick?){
  await this._formUtils.blurAndDelay();
  if (frmSideClick) {
      this.notificationDisplayFG.patchValue({
        fromDate: this.yesterday,
        toDate: this.today,
        subType: 2,
        pageNumber: this.paginationModel.pageNumber,
        pageSize: this.paginationModel.pageSize
      });
    }
        const resp = this._formUtils.checkDateErrors(this.notificationDisplayFG, "fromDate", "toDate", 0);
       if (resp === "DATEISSUE") {
            this._alertSer.error(MsgConfig.DATE_RANGE_ERROR);
        } else if (resp === "INVALID") {
            this._alertSer.error(MsgConfig.INVALID_DATES_ERROR);
        } else {
          const subTypeVal = (val ? (val.Id === 2 ? null : val.Id) : (this.notificationDisplayFG.value.subType === 2 ? null : this.notificationDisplayFG.value.subType))
          const data={
            fromDate: this.notificationDisplayFG.controls["fromDate"].value,
            toDate : this.notificationDisplayFG.controls["toDate"].value,
            pageNumber: this.notificationDisplayFG.controls["pageNumber"].value,
            pageSize: this.notificationDisplayFG.controls["pageSize"].value,
            subType : subTypeVal
            
          }
          this._rxService.getDetailsForNotificationDisplay(data).subscribe(resp=>{
            if(resp){
              this.CountDetails =  resp['CountDetails'];
              // this.userReviewStatus = resp['UserReviewStatus'];
              this.date = moment().utc( resp['CountDetails'].CreatedDtTm).local().format(MsgConfig.DATE_FORMAT);
              this.nabpNum = resp['NABPNo'];
              const readNotification = {
                fromDate: this.notificationDisplayFG.controls["fromDate"].value,
                toDate : this.notificationDisplayFG.controls["toDate"].value
              }
              this._rxService.detailsForDisplayNotificationCount(readNotification).subscribe(notifCount=>{
                if(notifCount){
                  this.notificationCountAfterPreview.emit(notifCount);
                }
              })
              if (this.CountDetails?.length) {
                this.totalCount = this.CountDetails[0] ? this.CountDetails[0]["TotalCount"] : 0;
                this.loadReportData(this.CountDetails);
                let successData = this.CountDetails.filter(item=>{
                  return item.SuccessCount > 0
                })
                this.successCount = successData;
                let errorData = this.CountDetails.filter(item=>{
                  return item.ErrorCount > 0
                })
                this.ErrorCount = errorData;
                let zeroReportData = this.CountDetails.filter(item=>{
                  return item.RxCount === 0
                })
                this.RxCount = zeroReportData;
              } else {
                this.totalCount = 0;
                this.displaySuccessCount = new CollectionView(null)
              }
            }
          })
        }
}
async preview(val: any,bool?) {
  this.alreadyRead = !this.alreadyRead;
  const readNotification = {
    CreatedDtTm : bool? moment.utc(val.CreatedDtTm).local().format("MM/DD/YYYY hh:mm:ss a") :  val["NotificationDateTime"],
    StateName: bool ? val.StateName : val.State,
    fromDate: this.notificationDisplayFG.controls["fromDate"].value,
    toDate : this.notificationDisplayFG.controls["toDate"].value
  }
  this._rxService.detailsForDisplayNotificationCount(readNotification).subscribe(notificationCount=>{
  if(notificationCount){
      let fileName = val["FileName"];
      let Id = fileName.split(".")[0];
      let Ids:any;
      if(val['FileTypeId'] === 2){
          Ids = "Error" + Id;
      }else{
          Ids = Id;
      }
      const payload ={
          controlId : Ids,
          CreatedDateTime :val.NotificationDateTime
      }
      this._controlFileSvc.previewControlFile(payload).pipe(takeUntil(this.unsubscribe$)).subscribe(resp => {
          if (resp) {
              this.previewWJ = resp;
              this.previewPdf(resp);
          }
      });
  // const payload = {
  //   CreatedDtTm : bool?  moment.utc(val.CreatedDtTm).local().format("MM/DD/YYYY hh:mm:ss a") : val["NotificationDateTime"],
  //   RxCount: val.RxCount,
  //   ErrorCount: val.ErrorCount,
  //   SuccessCount: val.SuccessCount,
  //   FailureCount: val.FailureCount,
  //   StateName:  bool ? val.StateName : val.State,
  //   NABPNo:this.nabpNum,
  // }
  // this._rxService.notAutoSubmittedData(payload).subscribe(resp=>{
  // if(resp){
  // this.previewPdf(resp);
  // this.onSearch();
  // }
  // })

  }
  })

}
previewPdf(resp) {
  if (resp && resp.size > 0 && resp.type === "application/pdf") {
      const urlCreator = window.URL;
      this.pdfSrc = this.sanitizer.bypassSecurityTrustResourceUrl(
          urlCreator.createObjectURL(resp) + "#toolbar=0"
      );
  }

}
download(val){
    /*const payload = {
      CreatedDtTm : val["NotificationDateTime"],
      RxCount: val.RxCount,
      ErrorCount: val.ErrorCount,
      SuccessCount: val.SuccessCount,
      FailureCount: val.FailureCount,
      StateName: val.State,
      NABPNo:this.nabpNum,
  }
  this._rxService.notAutoSubmittedData(payload).subscribe(resp=>{
  if(resp){
    this.printNotif = resp;
    this.printReport();
  }
  })*/
      let fileName = val["FileName"];
      fileName = (val && val['FileTypeId'] === 2) ? "Error" + fileName  : fileName;
      this._docService.getDocumentByName({ FileName: fileName ,IsControlFile:true }).pipe(takeUntil(this.unsubscribe$)).subscribe(resp => {
          if (resp) {
              this.setUpForDownload(resp, val["FileName"]);
          }
      });
}
printReport() {
  const newBlob = new Blob([this.printNotif], { type: "application/pdf" });
  const reader = new FileReader();
  reader.readAsDataURL(newBlob);
  reader.onloadend = function() {
      const base64data = reader.result;
      this._printServ.printPdf(base64data);
  }.bind(this);
}
  setUpForDownload(response: any, fileName: any) {
    const a: any = document.createElement("a");
    a.style = "display: none";
    const data: any = response;
    const url = URL.createObjectURL(data);
    a.href = url;
    a.download = fileName;
    a.click();
  }
openSuccess(){
this.submissionNotif = true;
this.controlFileErrorNY = false;
this.controlError = false;
this._storageService.getWijmoGridDataInSession(this.wjHeaders,"controlFileError");
  this._storageService.getWijmoGridDataInSession(this.wjHeaders2,"controlFileErrorForNY");
}
openControlFileError(){
  this.submissionNotif = false;
  this.controlFileErrorNY = false;
  this.controlError = true;
  this._storageService.getWijmoGridDataInSession(this.wjHeaders3,"submissionLog");
  this._storageService.getWijmoGridDataInSession(this.wjHeaders2,"controlFileErrorForNY");
}
openControlFileErrorForNY(){
  this.submissionNotif = false;
  this.controlFileErrorNY = true;
  this.controlError = false;
  this._storageService.getWijmoGridDataInSession(this.wjHeaders,"controlFileError");
  this._storageService.getWijmoGridDataInSession(this.wjHeaders3,"submissionLog");
}
async searchForControlErrorData(val?){
  await this._formUtils.blurAndDelay();
  const resp = this._formUtils.checkDateErrors(this.notificationDisplayFG, "FromDate", "ToDate", 0);
 if (resp === "DATEISSUE") {
      this._alertSer.error(MsgConfig.DATE_RANGE_ERROR);
  } else if (resp === "INVALID") {
      this._alertSer.error(MsgConfig.INVALID_DATES_ERROR);
  } else {
    this.selectedFilter = val ? val : {Id: (this.notificationDisplayFG.controls["statusDropdwn"].value === 0 ? 0 : (this.notificationDisplayFG.controls["statusDropdwn"].value === 1 ? 1 : 2)),
    Name: (this.notificationDisplayFG.controls["statusDropdwn"].value === 0 ? resolveErrorEnum.ALL :( this.notificationDisplayFG.controls["statusDropdwn"].value === 1 ? resolveErrorEnum.Unresolved : resolveErrorEnum.Resolved))} ;
  this.selectedError = (val && val.Id) ? val.Id : this.notificationDisplayFG.controls["statusDropdwn"].value;
  const payload={
    fromDate: this.notificationDisplayFG.controls["FromDate"].value,
    toDate : this.notificationDisplayFG.controls["ToDate"].value,
    ErrorStatus: this.selectedError,
    pageNumber: this.notificationDisplayFG.controls["pageNumber"].value,
    pageSize:this.notificationDisplayFG.controls["pageSize"].value
  }
  this._rxService.dataOfcontrolErrorfile(payload).subscribe(resp=>{
    if(resp){
      this.errorResponse = resp;
      this.errors = resp['errors'];
      this.totalRecordsLength = resp['rxData'].length;
      this.resolvedCount = this.errors.filter(resp=>{
        return resp.ErrorUpdateStatus === 2
      })
      this.unResolvedCount = this.errors.filter(resp=>{
        return resp.ErrorUpdateStatus === 1
      })
      this.generateControlErrorWJ();
    }
  })
  }
}
generateControlErrorWJ() {
  this.controlErrorWJ = new CollectionView(
      this.errorResponse.rxData.map((ctrlFile, i) => {
          const k = {};
          k["RowId"] = i;
          k["Rx#"] = ctrlFile.Prescription.PrescNum;
          k["Ref#"] = ctrlFile.PrescReFill.ReFillNum;
          k["Fill#"] = this._cmnSvc.checkIsPartialFill(ctrlFile.PrescReFill, ctrlFile.Prescription)
          ? ctrlFile.PrescReFill.PartialFillNo : "";
          k["PrescRefillId"] = ctrlFile.PrescReFill.Id;
          k["Date Filled"] = moment.utc(ctrlFile.PrescReFill.FillDtTm).local().format(MsgConfig.DATE_FORMAT);
          k["Patient Name"] = ctrlFile.Patient.lastname + ", " + ctrlFile.Patient.firstname;
          k["Drug Name"] = this._formatsUtil.displaytallmanlettering(ctrlFile?.Drug);
          k["tallmanDrugNameExists"] = ctrlFile?.Drug?.tallmanDrugName ? true : false
          // ctrlFile.Drug.drugname + " " + ctrlFile.Drug.strength + " " + ctrlFile.Drug.drugformname;
          let errorObj = this.errorResponse.errors.find((err,j)=> err.RxNumber == ctrlFile.Prescription.PrescNum && err.RefillNumber == ctrlFile.PrescReFill.ReFillNum && i === j );
          if (errorObj) {
              k["Control Error"] = errorObj.Error;
              k["Id"] = errorObj.Id;
              k["ErrorUpdateStatus"] = errorObj.ErrorUpdateStatus
          } else {
              k["Control Error"] = "";
          }
          k["Resolved Date"] = errorObj && errorObj.ResolvedDtTm ? moment.utc(errorObj.ResolvedDtTm).local().format(MsgConfig.DATE_FORMAT) : "";
          k["Amount"] =  ctrlFile.PrescReFill.TotalAmt ? "$" + (parseFloat(ctrlFile.PrescReFill.TotalAmt + "")).toFixed(2) : "$0.00";
          k["Billed"] = ctrlFile.PrescReFill.BalDue ? "$" + (parseFloat(ctrlFile.PrescReFill.BalDue + "")).toFixed(2) : "$0.00";
          let paidPrice = 0;
          let hasPayRecrds = false;
          if (ctrlFile && ctrlFile.RxPay && ctrlFile.RxPay.length > 0) {
              hasPayRecrds = ctrlFile.RxPay.some(pay => pay.RecType !== "R");
              ctrlFile.RxPay.map(val => {
                  if (val.RecType !== "R" || (val.RecType === "R" && val.REJCodes === "70")) {
                      paidPrice = paidPrice + val.InsNetPaid;
                  }
              });
          }
          k["Insu Paid"] = !paidPrice ? "$0.00" : "$" + (paidPrice).toFixed(2);
          k["Copay"] = ctrlFile.PrescReFill.CoPay ? "$" + (parseFloat(ctrlFile.PrescReFill.CoPay + "")).toFixed(2) : "$0.00";
          k["Prescriber Name"] = ctrlFile && ctrlFile.Prescriber ? (ctrlFile.Prescriber.prescriberlastname + ", " + ctrlFile.Prescriber.prescriberfirstname) : "";
          k["NDC"] = this._formatsUtil.getNDCFormat(ctrlFile.Drug.ndc) ;
          k["Date Ordered"] = moment.utc(ctrlFile.PrescReFill.OrderDtTm).local().format(MsgConfig.DATE_FORMAT);
          k["Status"] = (ctrlFile.PrescReFill.StatusId === 4 || ctrlFile.Prescription.RxStatusId === 4) ? "T" :
          (ctrlFile.PrescReFill.StatusId === 2 || ctrlFile.Prescription.RxStatusId === 2 || ctrlFile.RxBill.StatusId === 6) ? "F" :
                  (ctrlFile.PrescReFill.StatusId === 3
                      || ctrlFile.Prescription.RxStatusId === 3) && ctrlFile.RxBill.StatusId === 2 ? "BI" :
                      (ctrlFile.RxBill.StatusId === 2 && ctrlFile.PrescReFill.StatusId !== 4
                          && ctrlFile.Prescription.RxStatusId !== 2) ? "B" :
                          ((ctrlFile.PrescReFill.StatusId === 3 || ctrlFile.Prescription.RxStatusId === 3) &&
                              ctrlFile.RxBill.StatusId === 1) ? "UI" : "U";
          let insurence = null;
          if (ctrlFile.Patient && ctrlFile.Patient.insurance && ctrlFile.Patient.insurance.length > 0) {
              insurence = ctrlFile.Patient.insurance.find(insuObj => insuObj.insuranceid == ctrlFile.RefillInsu.InsuId);
              // insurence = _.filter(ctrlFile.Patient.insurance, {
              //     insuranceid: +ctrlFile.RefillInsu.InsuId
              // })[0];
          }
          k["IsBilled"] = this._comnUtil.checkIsGreenBilled(ctrlFile, this.systemData);
          k["Ins."] = (insurence && insurence.insuType) ? insurence.insuType : "";
          k["IsPicked"] = ctrlFile.pickupRx && ctrlFile.pickupRx.IsPickedUp ? true : false;
          k["IsPartiallyPickedup"] = ctrlFile.pickupRx ? ctrlFile.pickupRx.IsPartialPickup : false;
          k["Qty"] = ctrlFile.PrescReFill.DispQty.toFixed(3);
          k["Days"] = ctrlFile.PrescReFill.SupplyDays;
          k["DrugClass"] = ctrlFile.Drug.drugclass;
          k["StatusHoverOver"] = this._hoverOver.getStatusHoverOver(k);
          k["DrugHoverOver"] = this._hoverOver.getDrugNameHoverOver(k);
          const rowId = k["RowId"] >= 0 ? k["RowId"] : "";
          const RxDetails = rowId >= 0 ?  this.errorResponse["rxData"][rowId] : null;
          k["RxHoverOver"] = this._colorCodeRx.showRxColorCodeAndHoverOver(RxDetails, "RxObject", "Rx", "hoverOver");
          return k;
      }));
}
routeToEditRx(item: any, type?) {
  let errorList = type === 'NYErrors' ? this.errorsNY : this.errors;
  let Ids = errorList.filter(resp=>{
    return resp.Id === item.Id
  })
  const readNotification = {
    fromDate: this.notificationDisplayFG.controls["FromDate"].value,
    toDate : this.notificationDisplayFG.controls["ToDate"].value
  }
  this._rxService.detailsForDisplayNotificationCount(readNotification).subscribe(notifCount=>{
  if(notifCount) {
    this.notificationCountAfterPreview.emit(notifCount);
    this.selectedrxNo = item["Rx#"];
    this.selectedrxId = item["PrescRefillId"];
    if (this.checkHasPrivsToAccess(
        this.accessPrivCate.Rx,
        this.rxPrivs.EditRx)) {
            this.routeToRx(Ids, 'NYErrors');
    } else {
        this.openOveride("Rx", "EditRx", ["POST_Rx_GetRxDetails", "PUT_Rx"]);
    }
  }
 })
}
checkHasPrivsToAccess(category: string, privType: string) {
  return this._privMaskGuard.canActivate(category, privType);
}
async routeToRx(item?, type?) {
  let rxInfo: any = await this._nrxUtls.getandStoreRxInfo(+this.selectedrxNo, +this.selectedrxId, false, null, null, null, true,null, null, null, true);
  if (rxInfo) {
      rxInfo = this._nrxUtls.editRxPatchValues(rxInfo);
      this._nrxUtls.createPatchStoreRxFG(rxInfo);
      this._nrxUtls.getCommonEndPoints(rxInfo);
      const modalRef = this._modalService.open(
          EdRxComponent,
          {
              backdrop: false,
              size: "lg",
              windowClass: "md-xx-lg comp--modal",
              keyboard: false
          }
      );
      modalRef.componentInstance.errorEditInfo = item ? item[0] : "";
      modalRef.componentInstance.isNYCntrlFileErr = type === 'NYErrors' ? true : false;
      modalRef.componentInstance.isFromCntrlFileErr = true;
      modalRef.componentInstance.CloseEditMode
          .subscribe(x => {
              modalRef.close();
              this._commonStore.notifCount$.subscribe(resp=>{
                this.notificationCountAfterPreview.emit(resp);
                this.searchForControlErrorData();
                })

          });

      modalRef.componentInstance.CloseAndReopen
          .subscribe(d => {
              modalRef.close();
              if (d) {
                  this.selectedrxNo = d["rxNo"];
                  this.selectedrxId = d["rfId"];
                  this.routeToRx();
              }
          });
  }
}
openOveride(category, type, endpoint?) {
  this.categoryId = category;
  this.privType = type;
  this.openOverride = true;
  this.overrideEndpoint = endpoint;
}
init(flex: wjcGrid.FlexGrid) {
  this.rxWijmo = flex;
}
itemFormatter = (panel, r, c, cell) => {
  const row = panel.rows[r];
  if (row.dataItem) {
      cell.style.background = "";
      if (panel.cellType === wjcGrid.CellType.Cell && panel.columns[c].binding === "Rx#") {
        const rowId = row && row.dataItem ? row.dataItem["RowId"] : "";
        const RxDetails = rowId >= 0 ? this.controlFileErrorNY ? this.errorResponseNY["rxData"][rowId] : this.errorResponse["rxData"][rowId] : null;
        const colors = this._colorCodeRx.showRxColorCodeAndHoverOver(RxDetails, "RxObject", "Rx");
          if(colors && colors.bg && colors.color) {
              cell.style.background = colors.bg;
              cell.style.color = colors.color;
          } else {
              cell.style.background = "#FFF";
              cell.style.color = "#000";
          }
          cell.style.fontWeight = "bold";
          cell.style.paddingLeft = "1rem";
      } else if (panel.cellType === wjcGrid.CellType.Cell && panel.columns[c].binding === "Drug Name") {
          const colors = this._colorCode.showDrugColorRefactoring(row.dataItem);
          if(colors && colors.bg && colors.color) {
              cell.style.background = colors.bg;
              cell.style.color = colors.color;
          } else {
              cell.style.background = "#FFF";
              cell.style.color = "#000";
          }
          cell.style.fontWeight = "bold";
          cell.style.paddingLeft = "1rem";
      } else if (panel.cellType === wjcGrid.CellType.Cell && panel.columns[c].binding === "Status") {
          const colors = this._colorCode.showRxStatusColorRefactoring(row.dataItem);
          if(colors && colors.bg && colors.color) {
              cell.style.background = colors.bg;
              cell.style.color = colors.color;
          } else {
              cell.style.background = "#FFF";
              cell.style.color = "#000";
          }
          cell.style.fontWeight = "bold";
          cell.style.paddingLeft = "1rem";
      } else {
          cell.style.backgroundColor = "#FFF";
          cell.style.color = "#000";
          cell.style.fontWeight = "normal";
          cell.style.textAlign = "initial";
      }
  }
}
toggleColorLegend() {
  this._alertSer.showHelpText({RxStatus: true, DrugName: true, Status: true});
}
searchForControlErrorDataOnload(){
  this.selectedFilter = {Id:1, Name:'Unresolved'}
  this.notificationDisplayFG.patchValue({
        FromDate: this.yesterday,
        ToDate: this.today,
        statusDropdwn: 1,
        pageNumber: this.paginationModel.pageNumber,
        pageSize: this.paginationModel.pageSize
  });
  const payload={
    // fromDate: null,
    // toDate : null,
    ErrorStatus: 1,
    fromDate: this.notificationDisplayFG.controls["FromDate"].value,
    toDate :this.notificationDisplayFG.controls["ToDate"].value,
    pageNumber: this.paginationModel.pageNumber,
    pageSize:this.paginationModel.pageSize
    
  }
  this.notificationDisplayFG.controls["statusDropdwn"].patchValue(1);
  this._rxService.dataOfcontrolErrorfile(payload).subscribe(resp=>{
    if(resp){
      this.notificationDisplayFG.controls["FromDate"].patchValue((resp['ErrorFileMinDate'] && (resp['ErrorFileMinDate'] != '0001-01-01T00:00:00')) ?(moment.utc(resp['ErrorFileMinDate']).local().format(
        MsgConfig.DATE_FORMAT)):this.yesterday);
        this.notificationDisplayFG.controls["ToDate"].patchValue((resp['ErrorFileMaxDate'] && (resp['ErrorFileMaxDate'] != '0001-01-01T00:00:00')) ?(moment.utc(resp['ErrorFileMaxDate']).local().format(
          MsgConfig.DATE_FORMAT)):this.today)
      this.errorResponse = resp;
      this.errors = resp['errors'];
      this.totalRecordsLength = resp['rxData'].length;
      this.resolvedCount = this.errors.filter(resp=>{
        return resp.ErrorUpdateStatus === 2
      })
      this.unResolvedCount = this.errors.filter(resp=>{
        return resp.ErrorUpdateStatus === 1
      })
      this.generateControlErrorWJ();
    }
  })
}
async searchNYErrors(val?, frmSideClick?){
  await this._formUtils.blurAndDelay();
  if (frmSideClick) {
      this.notificationDisplayFG.patchValue({
        FromDate: this.yesterday,
        ToDate: this.today,
        statusDropdwn: 1,
        pageNumber: this.paginationModel.pageNumber,
        pageSize: this.paginationModel.pageSize
      });
  }
  const resp = this._formUtils.checkDateErrors(this.notificationDisplayFG, "FromDate", "ToDate", 0);
  if (resp === "DATEISSUE") {
      this._alertSer.error(MsgConfig.DATE_RANGE_ERROR);
  } else if (resp === "INVALID") {
      this._alertSer.error(MsgConfig.INVALID_DATES_ERROR);
  } else {
    this.selectedFilter = val ? val : {Id: (this.notificationDisplayFG.controls["statusDropdwn"].value === 0 ? 0 : (this.notificationDisplayFG.controls["statusDropdwn"].value === 1 ? 1 : 2)),
    Name: (this.notificationDisplayFG.controls["statusDropdwn"].value === 0 ? resolveErrorEnum.ALL :( this.notificationDisplayFG.controls["statusDropdwn"].value === 1 ? resolveErrorEnum.Unresolved : resolveErrorEnum.Resolved))} ;
    this.selectedError = (val && val.Id) ? val.Id : this.notificationDisplayFG.controls["statusDropdwn"].value;
    const payload={
    FromDate: this.notificationDisplayFG.controls["FromDate"].value,
    ToDate : this.notificationDisplayFG.controls["ToDate"].value,
    ErrorStatus: this.selectedError,
    pageNumber: this.notificationDisplayFG.controls["pageNumber"].value,
    pageSize: this.notificationDisplayFG.controls["pageSize"].value,
    }
    this._rxService.showNYErrors(payload).subscribe(resp=>{
    if(resp){
      this.errorResponseNY = resp;
      this.errorsNY = resp['ErrorDetails']?.length ? resp['ErrorDetails'] : [];
      this.totalNYRecordsLength = resp['rxData'] ? resp['rxData']?.length : 0;
      this.resolvedCountNY = this.errorsNY?.length ? this.errorsNY.filter(resp=>{
        return resp.ErrorUpdateStatus === 2
      }) : [];
      this.unResolvedCountNY = this.errorsNY?.length ? this.errorsNY.filter(resp=>{
        return resp.ErrorUpdateStatus === 1
      }) : [];
      if (resp['rxData']?.length)
        this.displayingNYErrors();
      else
        this.showNYErrorsWJ = new CollectionView(null)
    }
  })
  }
}
// searchNYErrors(val?){
//   let payload:any;
//   payload = {
//     FromDate: this.notificationDisplayFG.controls["fromDate"].value,
//     ToDate:this.notificationDisplayFG.controls["toDate"].value,
//     ErrorCode :null,
//     PatientId :null,
//     StateId :null,
//     pageNumber: this.notificationDisplayFG.controls["pageNumber"].value,
//     pageSize:this.notificationDisplayFG.controls["pageSize"].value,
//   }
//   this._rxService.showNYErrors(payload).subscribe(resp=>{
//   this.newYorkErros = resp;
//   this.displayingNYErrors(resp);
//   })
// }
displayingNYErrors(){
/*this.showNYErrorsWJ = new CollectionView(
  data.map((err,i)=>{
    const p = {}
    p["Rx#"] = err.PrescNum ? err.PrescNum : "" ;
    p["Ref#"] = err.ReFillNum ?err.ReFillNum  :"";
    p["Fill#"] = err.PartialFillNum ? err.PartialFillNum :"";
    p["Patient Name"] = err.PatientName ? err.PatientName : "";
    p["Drug Name"] = err.DrugName ? err.DrugName : "";
    p["NDC"] = err.DrugNDC ? err.DrugNDC : "";
    p["Fill Date"] = err.DateFilled ? err.DateFilled :"";
    p["Prescriber Name"] = err.Prescriber ? err.Prescriber : "";
    p["Ins."] = err.Insurance ? err.Insurance : "";
    p["Error Code"] = err.FieldCode ? err.FieldCode : "";
    p["Error Description"] = err.FieldDescription ? err.FieldDescription : "";
    p["Value Provided"] = err.ValueProvided ? err.ValueProvided : "";
    p["Comment"] = err.Comment ? err.Comment : "";
    p["Submitted Date"] = err.DateSubmitted ? err.DateSubmitted : "";
    return p;
  }))*/
  this.showNYErrorsWJ = new CollectionView(
      this.errorResponseNY.rxData.map((errFile, i) => {
          const k = {};
          k["RowId"] = i;
          k["Rx#"] = errFile.Prescription.PrescNum;
          k["Ref#"] = errFile.PrescReFill.ReFillNum;
          k["Fill#"] = this._cmnSvc.checkIsPartialFill(errFile.PrescReFill, errFile.Prescription)
          ? errFile.PrescReFill.PartialFillNo : "";
          k["PrescRefillId"] = errFile.PrescReFill.Id;
          k["Date Filled"] = moment.utc(errFile.PrescReFill.FillDtTm).local().format(MsgConfig.DATE_FORMAT);
          k["Patient Name"] = errFile.Patient.lastname + ", " + errFile.Patient.firstname;
          k["Drug Name"] = this._formatsUtil.displaytallmanlettering(errFile?.Drug);
          k["tallmanDrugNameExists"] = errFile?.Drug?.tallmanDrugName ? true : false
          // errFile.Drug.drugname + " " + errFile.Drug.strength + " " + errFile.Drug.drugformname;
          let errorObj = this.errorResponseNY.ErrorDetails.find((err,j)=> err.PrescNum == errFile.Prescription.PrescNum && err.ReFillNum == errFile.PrescReFill.ReFillNum && err.PartialFillNum === errFile.PrescReFill.PartialFillNo && i === j );
          if (errorObj) {
              k["Control Error"] = errorObj.FieldDescription;
              k["Id"] = errorObj.Id;
              k["ErrorUpdateStatus"] = errorObj.ErrorUpdateStatus;
          } else {
              k["Control Error"] = "";
          }
          k["Resolved Date"] = errorObj && errorObj.ResolvedDtTm ? moment.utc(errorObj.ResolvedDtTm).local().format(MsgConfig.DATE_FORMAT) : "";
          k["Amount"] =  errFile.PrescReFill.TotalAmt ? "$" + (parseFloat(errFile.PrescReFill.TotalAmt + "")).toFixed(2) : "$0.00";
          k["Billed"] = errFile.PrescReFill.BalDue ? "$" + (parseFloat(errFile.PrescReFill.BalDue + "")).toFixed(2) : "$0.00";
          let paidPrice = 0;
          let hasPayRecrds = false;
          if (errFile && errFile.RxPay && errFile.RxPay.length > 0) {
              hasPayRecrds = errFile.RxPay.some(pay => pay.RecType !== "R");
              errFile.RxPay.map(val => {
                  if (val.RecType !== "R" || (val.RecType === "R" && val.REJCodes === "70")) {
                      paidPrice = paidPrice + val.InsNetPaid;
                  }
              });
          }
          k["Insu Paid"] = !paidPrice ? "$0.00" : "$" + (paidPrice).toFixed(2);
          k["Copay"] = errFile.PrescReFill.CoPay ? "$" + (parseFloat(errFile.PrescReFill.CoPay + "")).toFixed(2) : "$0.00";
          k["Prescriber Name"] = errFile && errFile.Prescriber ? (errFile.Prescriber.prescriberlastname + ", " + errFile.Prescriber.prescriberfirstname) : "";
          k["NDC"] = this._formatsUtil.getNDCFormat(errFile.Drug.ndc) ;
          k["Date Ordered"] = moment.utc(errFile.PrescReFill.OrderDtTm).local().format(MsgConfig.DATE_FORMAT);
          k["Status"] = (errFile.PrescReFill.StatusId === 4 || errFile.Prescription.RxStatusId === 4) ? "T" :
          (errFile.PrescReFill.StatusId === 2 || errFile.Prescription.RxStatusId === 2 || errFile.RxBill.StatusId === 6) ? "F" :
                  (errFile.PrescReFill.StatusId === 3
                      || errFile.Prescription.RxStatusId === 3) && errFile.RxBill.StatusId === 2 ? "BI" :
                      (errFile.RxBill.StatusId === 2 && errFile.PrescReFill.StatusId !== 4
                          && errFile.Prescription.RxStatusId !== 2) ? "B" :
                          ((errFile.PrescReFill.StatusId === 3 || errFile.Prescription.RxStatusId === 3) &&
                              errFile.RxBill.StatusId === 1) ? "UI" : "U";
          let insurence = null;
          if (errFile.Patient && errFile.Patient.insurance && errFile.Patient.insurance.length > 0) {
              insurence = errFile.Patient.insurance.find(insuObj => insuObj.insuranceid == errFile.RefillInsu.InsuId);
          }
          k["IsBilled"] = this._comnUtil.checkIsGreenBilled(errFile, this.systemData);
          k["Ins."] = (insurence && insurence.insuType) ? insurence.insuType : "";
          k["IsPicked"] = errFile.pickupRx && errFile.pickupRx.IsPickedUp ? true : false;
          k["IsPartiallyPickedup"] = errFile.pickupRx ? errFile.pickupRx.IsPartialPickup : false;
          k["Qty"] = errFile.PrescReFill.DispQty.toFixed(3);
          k["Days"] = errFile.PrescReFill.SupplyDays;
          k["DrugClass"] = errFile.Drug.drugclass;
          k["StatusHoverOver"] = this._hoverOver.getStatusHoverOver(k);
          k["DrugHoverOver"] = this._hoverOver.getDrugNameHoverOver(k);
          const rowId = k["RowId"] >= 0 ? k["RowId"] : "";
          const RxDetails = rowId >= 0 ?  this.errorResponseNY["rxData"][rowId] : null;
          k["RxHoverOver"] = this._colorCodeRx.showRxColorCodeAndHoverOver(RxDetails, "RxObject", "Rx", "hoverOver");
          return k;
      }));
}
beforeTabChange(event) {
  this.IsActiveTabName = event;
  this._storageService.getWijmoGridDataInSession(this.wjHeaders,"controlFileError");
}
ngOnDestroy() {
  this._storageService.getWijmoGridDataInSession(this.wjHeaders,"controlFileError");
  
  this._storageService.getWijmoGridDataInSession(this.wjHeaders3,"submissionLog");
  this._storageService.getWijmoGridDataInSession(this.wjHeaders2,"controlFileErrorForNY");
  
}
  toggleTreeView(e) {
      const target = e.target as HTMLElement;

      // Reference to the clicked caret's container
      const container = target.closest('li');

      if (!container) return;

      const expandList = container.querySelector('.expandList');
      const isAlreadyExpanded = target.classList.contains('reportcaret-down');

      // Collapse all other trees
      const allExpandLists = document.querySelectorAll('.expandList');
      const allCarets = document.querySelectorAll('.reportcaret');

      allExpandLists.forEach(el => el.classList.remove('active'));
      allCarets.forEach(el => el.classList.remove('reportcaret-down'));

      // If it wasn't already expanded, expand it now
      if (!isAlreadyExpanded) {
        expandList?.classList.add('active');
        target.classList.add('reportcaret-down');
      }
    }
    focusToFirst(event) {
        if (document.getElementById("searchBtn")) {
            event.preventDefault();
            setTimeout(() => {
                document.getElementById("searchBtn").focus();
            }, 10);
        }
    }
    setPage(page: number, type) {
        this.pageNumber = page;
        this.notificationDisplayFG.controls["pageNumber"].patchValue(this.pageNumber);
        if (type=== 'contrlError') {
          this.searchForControlErrorData();
        } else if (type === 'submNtif') {
          this.onSearch();
        } else if (type === 'NYcontrlError') {
          this.searchNYErrors();
        }
    }

    setSize(size: any, type) {
        this.pageNumber = 1;
        this.pageSize = size;
        this.notificationDisplayFG.controls["pageSize"].patchValue(this.pageSize);
        this.notificationDisplayFG.controls["pageNumber"].patchValue(this.pageNumber);
        if (type=== 'contrlError') {
          this.searchForControlErrorData();
        } else if (type === 'submNtif') {
          this.onSearch();
        } else if (type === 'NYcontrlError') {
          this.searchNYErrors();
        }
    }
}
